export var FlexMediaQueriesEnum;
(function (FlexMediaQueriesEnum) {
    FlexMediaQueriesEnum["sm"] = "(max-width: 640px)";
    FlexMediaQueriesEnum["md"] = "(min-width: 641px) and (max-width: 1023px)";
    FlexMediaQueriesEnum["lg"] = "(min-width: 1024px)";
})(FlexMediaQueriesEnum || (FlexMediaQueriesEnum = {}));
